import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, HtmlContent } from './ui';
import CardSlider from './CardSlider';
import FeaturedSpaCard from './FeaturedSpaCard';
import { slugify } from '../utils';

const StyledFeaturedSpas = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  position: relative;
`;

const StyledHeader = styled.header`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledHeading = styled(Heading)`
  padding-right: 160px;

  ${minBreakpointQuery.small`
    padding-right: 180px;
  `}
`;

const StyledContent = styled(HtmlContent)`
  margin-top: 12px;

  ${minBreakpointQuery.small`
    margin-top: 15px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 18px;
  `}
`;

const StyledItems = styled(CardSlider)`
  position: static;
`;

const StyledItem = styled(FeaturedSpaCard)`
  height: 100%;
`;

const StyledFooter = styled.footer`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 40px;
  `}
`;

const FeaturedSpas = ({
  heading,
  topContent,
  items,
  bottomContent,
  alt,
  isFeaturedSpaGroups,
}) => (
  <StyledFeaturedSpas {...(isFeaturedSpaGroups && { id: slugify(heading) })}>
    <Container>
      <StyledInner>
        <StyledHeader>
          <StyledHeading alt={true} forwardedAs={isFeaturedSpaGroups && 'h3'}>
            {heading || 'Featured Spas'}
          </StyledHeading>
          <StyledContent html={topContent} />
        </StyledHeader>
        <StyledItems dots={false}>
          {items.map((item, id) => (
            <StyledItem
              key={id}
              spa={item.spa ? item.spa : item}
              packages={item.packages}
              alt={alt}
              isFeaturedSpaGroups={isFeaturedSpaGroups}
            />
          ))}
        </StyledItems>
        {bottomContent && (
          <StyledFooter>
            <HtmlContent html={bottomContent} />
          </StyledFooter>
        )}
      </StyledInner>
    </Container>
  </StyledFeaturedSpas>
);

export default FeaturedSpas;
